import './AdditionallyInsured.css';

export default function AdditionallyInsuredFields({
    legalName = '',
    address = '',
    onLegalNameChange,
    onAddressChange,
    onEntityBlur,
    disabled = false,
    inputClassName = 'host-edit-input',
    textareaClassName = 'host-edit-textarea',
}) {
    return (
        <div className="insured-entities">
            <div className="insured-entities-title">Legal name &amp; address to be named</div>
            <p className="insured-entities-sub">
                Enter the legal entity (and its address) that must appear as additionally insured
                on the driver&apos;s certificate of insurance.
            </p>
            <div className="insured-entity">
                <input
                    className={inputClassName}
                    type="text"
                    placeholder="Legal name (e.g., Pilot Travel Centers LLC)"
                    value={legalName}
                    disabled={disabled}
                    onChange={(e) => onLegalNameChange?.(e.target.value)}
                    onBlur={() => onEntityBlur?.()}
                />
                <textarea
                    className={textareaClassName}
                    placeholder="Legal address"
                    style={{ minHeight: 60 }}
                    value={address}
                    disabled={disabled}
                    onChange={(e) => onAddressChange?.(e.target.value)}
                    onBlur={() => onEntityBlur?.()}
                />
            </div>
        </div>
    );
}
